(() => {
  const productRoot = document.querySelector('[data-product-root]');
  if (!productRoot) return;

  const price = productRoot.querySelector('[data-product-price]');
  const variantSelect = productRoot.querySelector('[data-variant-select]');
  const addButton = productRoot.querySelector('[data-add-to-cart]');
  const quantityInput = productRoot.querySelector('[data-quantity-input]');
  const mediaItems = [...productRoot.querySelectorAll('[data-product-media]')];

  const activateMedia = (targetId) => {
    const selectedMedia = mediaItems.find((item) => item.dataset.productMedia === String(targetId));
    if (!selectedMedia) return;

    mediaItems.forEach((item) => {
      const active = item === selectedMedia;
      item.hidden = !active;
      item.classList.toggle('is-active', active);
      if (!active) item.querySelectorAll('video').forEach((video) => video.pause());
    });

    productRoot.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
      const active = thumbnail.dataset.mediaTarget === String(targetId);
      thumbnail.classList.toggle('is-active', active);
      thumbnail.setAttribute('aria-pressed', String(active));
      if (active) thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });

  };

  productRoot.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
    button.addEventListener('click', () => {
      activateMedia(button.dataset.mediaTarget);
    });
  });

  variantSelect?.addEventListener('change', () => {
    const option = variantSelect.selectedOptions[0];
    const available = option.dataset.available === 'true';

    if (price) {
      price.innerHTML = `${option.dataset.comparePrice ? `<s>${option.dataset.comparePrice}</s>` : ''}<span>${option.dataset.price}</span>`;
    }
    if (option.dataset.mediaTarget) activateMedia(option.dataset.mediaTarget);
    if (addButton) {
      addButton.disabled = !available;
      addButton.querySelector('span').textContent = available ? 'Add to cart' : 'Sold out';
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });

  productRoot.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
  });
  productRoot.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
  });
})();
